export default __webpack_public_path__ + "static/media/icon_accounts_dashboard.b798a349.svg";